import { ReactNode } from 'react';

interface ActiveNotificationBadgeProps {
  children: ReactNode;
  show: boolean;
}

export function ActiveNotificationBadge({ children, show }: ActiveNotificationBadgeProps) {
  if (!show) return <>{children}</>;

  return (
    <div className="relative">
      {children}

      <div className="absolute -right-0.5 -top-1 h-2 min-h-2 w-2 min-w-2 shrink-0 rounded-full bg-destructive-dark" />
    </div>
  );
}
